module.exports = __webpack_public_path__ + "img/icon-close.1be2e548.svg";